const includesText = (value, terms) => {
  const text = String(value || '').toLowerCase();
  return terms.some((term) => text.includes(term));
};

const isAlreadyAssigned = ({ assignments, assignmentType, itemId }) => {
  return assignments.some((assignment) => {
    if (assignment.status === 'dismissed') return false;
    if (assignment.assignment_type !== assignmentType) return false;
    if (assignmentType === 'topic') return assignment.topic?.id === itemId;
    if (assignmentType === 'resource') return assignment.resource?.id === itemId;
    return assignment.track?.id === itemId;
  });
};

const findTrackBySlug = (catalog, slug) => {
  return (catalog.tracks || []).find((track) => track.slug === slug);
};

const findTopicBySlug = (catalog, slug) => {
  return (catalog.topics || []).find((topic) => topic.slug === slug);
};

export const buildLearningAssignmentSuggestions = ({ matter, catalog, assignments }) => {
  if (!matter || !catalog) return [];

  const suggestions = [];
  const planLooksTrustBased = includesText(matter.plan_type, ['trust'])
    || includesText(matter.matter_type, ['trust'])
    || includesText(matter.plan_type, ['revocable']);
  const planLooksPoaOnly = includesText(matter.plan_type, ['power of attorney', 'powers of attorney', 'poa']);

  if (planLooksTrustBased) {
    const trustTrack = findTrackBySlug(catalog, 'new-trust-orientation');
    if (trustTrack && !isAlreadyAssigned({ assignments, assignmentType: 'track', itemId: trustTrack.id })) {
      suggestions.push({
        id: 'new-trust-orientation-track',
        assignmentType: 'track',
        item: trustTrack,
        reason: 'This plan appears to use a trust, so this short orientation can prepare the client for trust documents and funding follow-up.',
        note: 'This short learning track will help you understand the trust documents and the follow-up steps that may come after signing.'
      });
    }

    const trustFundingTopic = findTopicBySlug(catalog, 'trust-funding');
    if (trustFundingTopic && !isAlreadyAssigned({ assignments, assignmentType: 'topic', itemId: trustFundingTopic.id })) {
      suggestions.push({
        id: 'trust-funding-topic',
        assignmentType: 'topic',
        item: trustFundingTopic,
        reason: 'Trust-based plans often need funding coordination after documents are signed.',
        note: 'This topic explains why funding matters and how assets may need to be connected to your trust.'
      });
    }
  }

  if (planLooksPoaOnly) {
    const poaTopic = findTopicBySlug(catalog, 'durable-financial-power-of-attorney');
    if (poaTopic && !isAlreadyAssigned({ assignments, assignmentType: 'topic', itemId: poaTopic.id })) {
      suggestions.push({
        id: 'durable-financial-power-of-attorney-topic',
        assignmentType: 'topic',
        item: poaTopic,
        reason: 'This plan appears focused on powers of attorney, so this topic can help explain the financial agent role.',
        note: 'This topic explains what a durable financial power of attorney does and how the financial agent role works.'
      });
    }
  }

  return suggestions;
};
